<template>
    <v-card>
        <v-card-title>
            Customer Search
        </v-card-title>
        <v-card-text>
            <v-form
                ref="form">
                <v-row>
                    <v-col>
                        <v-text-field
                            outlined
                            dense
                            label="Name"
                            v-model="form.name"
                            hide-details
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field
                            label="Code"
                            v-model="form.code"
                            hide-details
                            outlined
                            dense
                        >
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-text-field
                            label="Phone"
                            v-model="form.phone"
                            hide-details
                            outlined
                            dense
                            >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-autocomplete
                            dense
                            :label="$t('customer_group')"
                            outlined
                            hide-details
                            :items="customerGroups"
                            :loading="searchGroupLoading"
                            item-text="name"
                            item-value="id"
                            v-model="form.group_id"
                            @update:search-input="searchCustomerGroups"
                            clearable
                            >
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <user-search
                            :dense="true"
                            label="Created By"
                            hide-details
                            item-value="id"
                            item-text="name"
                            outlined
                            v-model="form.created_by_id"
                            append-icon="mdi-account">>
                        </user-search>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-autocomplete
                            dense
                            :label="$t('sales_person')"
                            outlined
                            hide-details
                            :items="salesPeople"
                            :loading="salesPeopleLoading"
                            item-text="name"
                            item-value="id"
                            v-model="form.sales_person_id"
                            @update:search-input="searchSalesPeople"
                            ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>

                        <v-menu
                            ref="menu_date_from"
                            v-model="menu.date_from"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="form.date_from"
                                    :rules="rules.date_from"
                                    :label="$t('date_from')"
                                    append-icon="mdi-calendar"
                                    hide-details
                                    outlined
                                    dense
                                    readonly
                                    v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="form.date_from" @input="menu.date_from = false" no-title scrollable></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-menu
                            ref="menu_date_to"
                            v-model="menu.date_to"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="form.date_to"
                                    :rules="rules.date_to"
                                    :label="$t('date_to')"
                                    append-icon="mdi-calendar"
                                    hide-details
                                    outlined
                                    dense
                                    readonly
                                    v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker :min="form.date_from" v-model="form.date_to" @input="menu.date_to = false" no-title scrollable></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-row no-gutters>
                <v-col class="me-1">
                    <v-btn
                        block
                        color="primary"
                        depressed
                        @click="submit"
                        :loading="loading"
                        :disabled="loading">
                        {{ $t("search") }}
                    </v-btn>
                </v-col>
                <v-col class="ms-1">
                    <v-btn text @click="resetForm" block outlined>
                        {{ $t("reset") }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
// import CustomerSearch from '../searchComponents/CustomerSearch';
import UserSearch from '../searchComponents/UserSearch';
import salesPerson from '../../services/sales/salesPerson';
import CustomerGroup from '../../services/sales/group';

export default {
    name: "CustomerSearchMenu",
    components: {
        // CustomerSearch,
        UserSearch
    },
    props: {
        loading: {
            required: false,
            type: Boolean
        }
    },
    data() {
        return {
            display: false,
            form: {
                name: null,
                code: null,
                date_from: null,
                date_to: null,
                created_by_id: null,
                phone: null,
                sales_person_id: null,
                group_id: null
            },
            menu: {
                date_from: false,
                date_to: false
            },
            rules: {
                date_from: [

                ],
                date_to: [

                ]
            },
            salesPeople: [],
            salesPeopleLoading: false,
            customerGroups: [],
            searchGroupLoading: false

        }
    },
    methods: {
        submit() {
            this.$emit("submit", this.form);
        },
        resetForm() {
            this.$refs.form.reset();
            this.form.customer_id = null;
        },
        searchSalesPeople(query) {
            this.salesPeopleLoading = true;
            salesPerson.search(query).then(res => {
                this.salesPeople = [...this.salesPeople, ...res.data];
            }).finally(() => {
                this.salesPeopleLoading = false;
            })
        },
        searchCustomerGroups(query) {
            this.searchGroupLoading = true;
            CustomerGroup.search(query).then(res => {
                this.customerGroups = [...this.customerGroups, ...res.data];
            }).finally(() => {
                this.searchGroupLoading = false;
            });
        }
    }
}
</script>